import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import instaIcon from "Assets/images/reportIntaIcon.png"
import phoneIcon from "Assets/images/reportPhoneIcon.png"
import clickIcon from "Assets/images/reportClickIcon.png"
import adRate from "Assets/images/adrate.png"

const styles = StyleSheet.create({
    footer: {
        position: "absolute",
        bottom: 20,
        left: 0,
        right: 0,
        padding: '0 60px 0 60px',
    },
    border: {
        borderBottom: "1px solid #000",
        marginBottom: 8,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    heading: {
        fontSize: 9,
        fontWeight: "bold",
        marginBottom: 4,
    },
    para: {
        fontSize: 8,
        lineHeight: 1.3,
    },
    link: {
        fontSize: 8,
        color: "#315D99",
    },
    inlineRow: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
    },
    icon: {
        width: 10,
        height: 10,
    },
});


export const PdfFooter = ({ data, type = "therapist" }) => {

    console.log('type of user', data)

    return (
        <View style={styles.footer} fixed>
            <View style={styles.border}></View>
            <View style={styles.row}>
                {/* Left Column */}
                <View style={{ width: "65%" }}>
                    <Text style={styles.heading}>KHAN COMMUNICATION SERVICES</Text>

                    <View style={{ paddingRight: "70px", ...styles.row, alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
                        <View style={styles.inlineRow}>
                            <Image style={styles.icon} src={instaIcon} />
                            <Text style={styles.link}>@khancommservices</Text>
                        </View>

                        <View style={styles.inlineRow}>
                            <Image style={styles.icon} src={clickIcon} />
                            <Text style={styles.link}>www.khancommunicationservices.com</Text>
                        </View>
                    </View>
                    <View style={{ flexDirection: "row", gap: 4, marginTop: 7 }}>
                        <Image style={styles.icon} src={clickIcon} />
                        <Text style={{ ...styles.para }}>
                            Parents have access to live workshops and education sessions. For the schedule and registration information go to:
                            <Text style={{ color: "#315D99" }}>
                                https://khancommunicationservices.com/home-education/workshops/
                            </Text>
                        </Text>
                    </View>
                </View>

                {/* Right Column */}
                <View style={{ width: "35%", alignItems: "flex-end" }}>
                    <View>
                        <Text style={styles.heading}>CONTACT THE INTAKE TEAM</Text>

                        <View style={styles.inlineRow}>
                            <Image style={styles.icon} src={adRate} />
                            <Text style={{ ...styles.link }}>homeed@khan-services.com</Text>
                        </View>

                        <View style={{ ...styles.inlineRow, marginTop: 8 }}>
                            <Image style={styles.icon} src={phoneIcon} />
                            <Text style={{ ...styles.link }}>(780)-440-3251</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}
